import React from 'react'

const SecondButton = ({ text }) => {
    return (
        <div className='px-4 md:px-8 py-2 border-2 border-[#6DA5C0] text-[#6DA5C0] duration-500 flex justify-center items-center rounded-lg cursor-pointer text-sm md:text-md font-bold'>{text}</div>
    )
}

export default SecondButton